

































































import { PropType } from 'vue'
import Dialog from '@/components/Dialog.vue'
import {
  Wholesaler,
  WholesalerTariff,
} from '@/utils/interfaces/remittance.interface'
import { TableHeader } from '@/utils/interfaces'
import WholesalerTariffDialog from '@/components/Services/Remittances/Wholesaler/WholesalerTariffDialog.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import ActionButton from '@/components/ActionButton.vue'

export default tableHandler<WholesalerTariff>().extend({
  components: {
    appDialog: Dialog,
    appWholesalerTariffDialog: WholesalerTariffDialog,
    appActionButton: ActionButton,
  },
  props: {
    item: Object as PropType<Wholesaler>,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('region'),
          value: 'region_name',
        },
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('min_amount'),
          value: 'min_amount',
        },
        {
          text: this.$t('max_amount'),
          value: 'max_amount',
        },
        {
          text: this.$t('min_commission'),
          value: 'min_commission',
        },
        {
          text: this.$t('percent_commission'),
          value: 'percent_commission',
        },
        {
          text: this.$t('active'),
          value: 'is_active',
        },
      ] as TableHeader[],
      search: '',
    }
  },
  computed: {
    tariffs(): WholesalerTariff[] {
      if (this.item && this.item.tariffs) {
        return this.item.tariffs.filter(
          item =>
            item.region_name
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            item.name.toLowerCase().includes(this.search.toLowerCase()),
        )
      } else return []
    },
  },
  methods: {
    onNew(item: WholesalerTariff) {
      const index = this.tariffs.findIndex(tariff => tariff.uuid === item.uuid)
      if (index !== -1) {
        this.item.tariffs.splice(index, 1, item)
      } else this.item.tariffs.push(item)
    },
  },
  created() {
    if (this.$store.getters.profile.role === 'ADMIN') {
      this.headers.push({
        text: this.$t('edit'),
        value: 'edit',
      })
    }
  },
})
